import React, { createContext, useState, useContext } from 'react'
import axios from "axios";
import Grid from '@mui/material/Grid';
import { Container, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Table, Column, Cell } from 'fixed-data-table-2';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import NewTrainingModal from './NewTrainingModal';
import moment from 'moment';
moment.locale("ja", {
    weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
    weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"]
  });
  
function StampCard() {
    const test = { id: 1 }


    const [CheckBoxSyahani, setCheckBoxSyahani] = useState(false);
    const [CheckBoxSyagai, setCheckBoxSyagai] = useState(false);
    const [CheckBoxtsushin, setCheckBoxtsushin] = useState(false);
    const [CheckBoxtosyo, setCheckBoxtosyo] = useState(false);
    const [Date, setDate] = useState();
    const [GridData, setGridData] = useState();


    const [open1, setOpen1] = useState(false);
    const handleOpen1 = () => setOpen1(true);
    const [shanaidata, setShanaiData] = useState();
    const [editshanaidata, setEditShanaiData] = useState();
    const [loading, setLoading] = useState(false);//検索中

    const saveEditingShanaiData = () => {
        setLoading(true);
        // let url = `http://localhost:5000/v1/training/events/search`;
        let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/events/search`;

        axios.post(url, {
            syanai: CheckBoxSyahani,
            syagai: CheckBoxSyagai,
            tsushin: CheckBoxtsushin,
            tosyo: CheckBoxtosyo,
            date: Date
        }).then((abc) => {
            console.log(abc.data);
            setGridData(JSON.parse(JSON.stringify(abc.data)));
            setEditShanaiData(JSON.parse(JSON.stringify(abc.data)));
            setLoading(false)
        });
        // console.log(shanaidata)
    }




    const check = (data) => {
        if (data.value == "1") {
            setCheckBoxSyahani(data.checked);
        } else if (data.value == "2") {
            setCheckBoxSyagai(data.checked);
        } else if (data.value == "3") {
            setCheckBoxtsushin(data.checked);
        } else if (data.value == "4") {
            setCheckBoxtosyo(data.checked);
        }
    }
    const dates = (data) => {
        setDate(new Date(data));
    }

    React.useEffect(() => {
        // let s_data = `http://localhost:5000/v1/training/events/list`;
        let s_data = process.env.REACT_APP_API_BASE_URL + `/v1/training/events/list`;
        axios.get(s_data).then((abc) => {
            setGridData(abc.data)
        });
    }, []);
    if (!GridData) return null;


    return (
        <div style={{ paddingTop: 60, paddingLeft: 70 }}>
            <Grid container sx={{ justifyContent: 'left', mt: 0 }}>
                <Grid item xs={3.2} sx={{ backgroundColor: 'white', borderRadius: 1, mr: 1, pt: 3, pl: 2, pr: 2, pb: 2, height: window.innerHeight - 75 }}>
                    <Typography sx={{ fontSize: 28, fontWeight: 'bold', textAlign: "left", marginLeft: 10 }} gutterBottom>登録</Typography>

                    <FormControl component="fieldset" style={{ marginLeft: 30 }}>
                        <FormGroup aria-label="position" row>
                            <FormControlLabel
                                value="1"
                                control={<Checkbox />}
                                label="社内"
                                labelPlacement="end"
                                sx={{ mr: 7, marginTop: 3 }}
                                onChange={(e) => { check(e.target) }}
                            />
                            <FormControlLabel
                                value="2"
                                control={<Checkbox />}
                                label="社外"
                                labelPlacement="end"
                                sx={{ mr: 7, marginTop: 3 }}
                                onChange={(e) => { check(e.target) }}
                            />
                            <FormControlLabel
                                value="3"
                                control={<Checkbox />}
                                label="通信講座"
                                labelPlacement="end"
                                sx={{ mr: 7, marginTop: 3 }}
                                onChange={(e) => { check(e.target) }}
                            />
                            <FormControlLabel
                                value="4"
                                control={<Checkbox />}
                                label="推薦図書"
                                labelPlacement="end"
                                sx={{ mr: 7, marginTop: 3 }}
                                onChange={(e) => { check(e.target) }}
                            />
                        </FormGroup>
                    </FormControl>

                    <TextField
                        style={{ marginTop: 30, width: 400, float: "left", marginLeft: 30 }}
                        type="date"
                        label="日程"
                        onChange={(e) => { setDate(e.target.value) }}
                        // value={editnewsdate ? editnewsdate.substr(0, 10) : ""}
                        value={Date}
                        // onChange={(e) => convertFormatForDateField(e.target.value)}
                        // defaultValue="2022-01-01"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />

                    <div>
                        <Button onClick={saveEditingShanaiData} variant="contained" sx={{ backgroundColor: "rgb(70 130 180)", width: 100, marginTop: 5, marginRight: 4, float: "right" }}>
                            検索
                        </Button>
                    </div>

                </Grid>

                <Grid item xs={8.6} sx={{ backgroundColor: 'white', borderRadius: 1, mr: 1, pt: 3, pl: 2, pr: 2, pb: 2 }}>
                    <div style={{ position: "relative" }}>
                        <Typography sx={{ fontSize: 15, fontWeight: 'bold', textAlign: "left" }} gutterBottom>登録済み一覧</Typography>


                        {loading ? "読み込み中" :
                            <Table className='Table' rowHeight={50} rowsCount={GridData.length} width={window.innerWidth / 1.5} height={window.innerHeight - 150} headerHeight={60}>
                                <Column isResizable={true} width={180} header={<Cell>日程</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].training_day ? moment(GridData[rowIndex].training_day).format('YYYY年MM月DD日(ddd)') : ""}</Cell>)}
                                />
                                <Column isResizable={true} width={100} header={<Cell>区分</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].training_division == 1 ? "社内"
                                            : GridData[rowIndex].training_division == 2 ? "社外"
                                                : GridData[rowIndex].training_division == 3 ? "通信講座"
                                                    : GridData[rowIndex].training_division == 4 ? "推薦図書" : ""}</Cell>)}
                                />
                                <Column isResizable={true} width={170} header={<Cell>カテゴリ</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].category_title}</Cell>)}
                                />
                                <Column isResizable={true} width={200} header={<Cell>タイトル</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell title={GridData[rowIndex].title} {...props}>
                                        {GridData[rowIndex].title}</Cell>)}
                                />
                                <Column isResizable={true} width={100} header={<Cell>主催者</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].promoter}</Cell>)}
                                />
                                <Column isResizable={true} width={100} header={<Cell><div>参加推奨</div><div>部門・階層</div></Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].recommended_section}</Cell>)}
                                />
                                <Column isResizable={true} width={100} header={<Cell>定員</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].capacity}</Cell>)}
                                />
                                <Column isResizable={true} width={100} header={<Cell>場所</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].place}</Cell>)}
                                />
                                <Column isResizable={true} width={100} header={<Cell>時間</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].training_time}</Cell>)}
                                />
                                <Column isResizable={true} width={100} header={<Cell>金額(1名)</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].training_amount}</Cell>)}
                                />
                                <Column isResizable={true} width={100} header={<Cell>定価</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].training_full_price}</Cell>)}
                                />
                                <Column isResizable={true} width={100} header={<Cell>コースNo</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].course_number}</Cell>)}
                                />
                                <Column isResizable={true} width={100} header={<Cell>本社貸出</Cell>}
                                    cell={({ rowIndex, ...props }) => (<Cell {...props}>
                                        {GridData[rowIndex].is_rental == 1 ? "✓" : ""}</Cell>)}
                                />
                            </Table>}

                        <AddCircleIcon onClick={handleOpen1} color="primary" style={{ fontSize: 65, position: "absolute", right: 30, bottom: 15, cursor: "pointer" }} />

                        <NewTrainingModal open={open1} setOpen={setOpen1} />

                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default StampCard;
